import actions from '@/vuex/modules/agency/actions'
import getters from '@/vuex/modules/agency/getters'
import mutations from '@/vuex/modules/agency/mutations'

const state = {
  loading: {
    searchResult: true,
  },
  agencyList: [],
  agencySearchResult: {},
}

const agency = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default agency
